import React, { useId } from "react";
import { motion } from "framer-motion";
import { spring } from "../../utils/motion";
interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  description?: string;
  hideLabel?: boolean;
}
export function Toggle({
  checked,
  onChange,
  label,
  description,
  hideLabel
}: ToggleProps) {
  const id = useId();
  return <div className="flex items-center justify-between gap-4" data-id="element-1240" data-mp="1cyb6aspfawli">
      {!hideLabel && <div className="min-w-0" data-id="element-1241" data-mp="y5himjzzza5r">
          <label htmlFor={id} className="block cursor-pointer text-[15px] font-semibold text-ink" data-id="element-1242" data-mp="12yu5opp138we">
            {label}
          </label>
          {description && <p className="mt-0.5 text-sm text-ink-2" data-id="element-1243" data-mp="p8qo4c13g3da">{description}</p>}
        </div>}
      <button id={id} type="button" role="switch" aria-checked={checked} aria-label={hideLabel ? label : undefined} onClick={() => onChange(!checked)} className={`focus-ring flex h-8 w-14 shrink-0 items-center rounded-full border-3 border-line p-0.5 transition-colors duration-150 ${checked ? "justify-end bg-brand" : "justify-start bg-sunken"}`} data-id="element-1244" data-mp="t90rdgxi4fog">
        <motion.span layout transition={spring.snappy} className="block h-5 w-5 rounded-full border-3 border-line bg-surface" data-id="element-1245" data-mp="10y8oysw0dchh" />
      </button>
    </div>;
}